'use strict';


module.exports = {
  routes: require('./routes')
};


